
const namespaced = true;

const state = {
  tabs: [
    { text: `Clients`, path: `/indeego-settings/clients` },
    { text: `Utilisateurs`, path: `/indeego-settings/users` },
    { text: `Visites utilisateurs`, path: `/indeego-settings/user-visits` },
    { text: `Logs`, path: `/indeego-settings/logs` },
  ],
};

const mutations = {};

const actions = {};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
